import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFilter2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconFilter2"><Path d="M2.75 4.75H21.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/><Path d="M8.75 19.25H15.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/><Path d="M5.75 12H18.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></CentralIconBase>;
});

export default IconFilter2;
